import { type Interceptor } from '@connectrpc/connect';
import { assertRpcPermissions, getMethodPermissionOptions, resolveAccountId } from '@/api/permissions';
import { ctxKeyQueryClient } from '@/connect-query/context-keys';

export const permissionsInterceptor: Interceptor = (next) => (req) => {
  const { requiredPermissions } = getMethodPermissionOptions(req.method);
  if (requiredPermissions.length === 0) {
    return next(req);
  }
  // The account scope is resolved from proto metadata (`account_id_expression`), which knows where the
  // account id lives in each request — top-level `accountId`, or nested like `cluster.accountId`.
  const accountId = resolveAccountId(req.method, req.message);
  if (!accountId) {
    throw new Error(
      'permissionsInterceptor: account scope could not be resolved from the request. ' +
        'Ensure the request contains a valid account ID.',
    );
  }

  // Handing over the query client lets the check pull the permissions out of the cache itself. It throws
  // when the $accountId route loader responsible for loading them has not run, which is a bug rather
  // than a denial.
  const queryClient = req.contextValues.get(ctxKeyQueryClient);
  assertRpcPermissions([req.method], { queryClient, accountId });

  return next(req);
};
